const API_URL =
  'https://fundaciontelefonica-graphics-data.s3.eu-west-1.amazonaws.com/actual'

const COUNTRIES_URL =
  'https://fundaciontelefonica-graphics-data.s3.eu-west-1.amazonaws.com/'
export default class Client {
  local = false
  url = null
  locale = null
  remoteURL = null
  country = null
  zone = null

  constructor (
    local = false,
    zone = 'spain',
    locale = 'es',
    remoteURL = API_URL,
    url = './'
  ) {
    this.local = local
    this.url = url
    this.remoteURL = remoteURL
    this.zone = this.getZone(zone)
    this.locale = locale
  }

  getZone (zone) {
    const codeZone = {
      es: 'ES',
      latam: 'LATAM',
      ar: 'AR'
    }

    return Object.prototype.hasOwnProperty.call(codeZone, zone)
      ? codeZone[zone]
      : zone
  }

  getFilename (file) {
    const source = {
      jobs: 'digitales',
      skills: 'habilidades',
      noDigital: 'nodigitales',
      skillsJobs: 'digitales-habilidades',
      skillsEvolution: 'evolucion-habilidades',
      digitalEvolution: 'evolucion-digitales',
      jobsQuestion: 'digitales-question',
      noDigitalQuestion: 'nodigitales-question',
      skillsQuestion: 'habilidades-question'
    }

    const filename = Object.prototype.hasOwnProperty.call(source, file)
      ? source[file]
      : file

    if (!this.local) {
      return `${filename}-${this.zone}-${this.locale}.json`
    }

    return `${filename}-${this.zone}-${this.locale}.json`
  }

  async fetch (url) {
    try {
      const res = await fetch(url)
      return await res.json()
    } catch (error) {
      // console.error(error)
    }
  }

  async getLocalData (file) {
    try {
      const filename = this.getFilename(file)
      const data = await this.fetch(`${this.url}data/${this.zone}/${this.locale}/${filename}`)

      return data
    } catch (error) {
      // console.error(error)
      return {}
    }
  }

  async getLocalGeoJson (file) {
    try {
      const data = await this.fetch(this.url + 'countries-geojson/' + file)
      return data
    } catch (error) {
      // console.error(error)
      return {}
    }
  }

  async getRemoteData (file) {
    try {
      const filename = this.getFilename(file)

      const data = await this.fetch(
        `${this.remoteURL}/${this.zone}/${this.locale}/` + filename
      )

      return data
    } catch (error) {
      // console.error(error)
      return {}
    }
  }

  async getRemoteGeoJson (file) {
    try {
      const data = await this.fetch(`${COUNTRIES_URL}countries-geojson/` + file)

      return data
    } catch (error) {
      // console.error(error)
      return {}
    }
  }

  async getData (file) {
    try {
      const getDataByLocation = this.local
        ? this.getLocalData(file)
        : this.getRemoteData(file)

      return await getDataByLocation
    } catch (error) {
      // console.error(error)
    }
  }

  async getGeoJson (file) {
    try {
      const getDataByLocation = this.local
        ? this.getLocalGeoJson(file)
        : this.getRemoteGeoJson(file)

      return await getDataByLocation
    } catch (error) {
      // console.error(error)
    }
  }
}
